module.exports = __webpack_public_path__ + "static/assets/b74ec159209748285e52978c613d235c.svg";